module.exports = __webpack_public_path__ + "static/media/008-Fenster_ID_1.31bd510e.mp3";